/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "expirationTimestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "withdrawalLiveness",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "collateralAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "tokenAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "finderAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "timerAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "financialProductLibraryAddress",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceFeedIdentifier",
                        type: "bytes32",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "minSponsorTokens",
                        type: "tuple",
                    },
                    {
                        internalType: "uint256",
                        name: "liquidationLiveness",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "collateralRequirement",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "disputeBondPercentage",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "sponsorDisputeRewardPercentage",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "disputerDisputeRewardPercentage",
                        type: "tuple",
                    },
                ],
                internalType: "struct Liquidatable.ConstructorParams",
                name: "params",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "ContractExpired",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
        ],
        name: "Deposit",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "disputer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "disputeSucceeded",
                type: "bool",
            },
        ],
        name: "DisputeSettled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "originalExpirationTimestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "shutdownTimestamp",
                type: "uint256",
            },
        ],
        name: "EmergencyShutdown",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
        ],
        name: "EndedSponsorPosition",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "FinalFeesPaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "liquidationId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokensOutstanding",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lockedCollateral",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidatedCollateral",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationTime",
                type: "uint256",
            },
        ],
        name: "LiquidationCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "disputer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidationId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "disputeBondAmount",
                type: "uint256",
            },
        ],
        name: "LiquidationDisputed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "paidToLiquidator",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "paidToDisputer",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "paidToSponsor",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "enum Liquidatable.Status",
                name: "liquidationStatus",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "settlementPrice",
                type: "uint256",
            },
        ],
        name: "LiquidationWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
        ],
        name: "NewSponsor",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
        ],
        name: "PositionCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
        ],
        name: "Redeem",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "regularFee",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "lateFee",
                type: "uint256",
            },
        ],
        name: "RegularFeesPaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "numTokensRepaid",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "newTokenCount",
                type: "uint256",
            },
        ],
        name: "Repay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldSponsor",
                type: "address",
            },
        ],
        name: "RequestTransferPosition",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldSponsor",
                type: "address",
            },
        ],
        name: "RequestTransferPositionCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldSponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newSponsor",
                type: "address",
            },
        ],
        name: "RequestTransferPositionExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
        ],
        name: "RequestWithdrawal",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
        ],
        name: "RequestWithdrawalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
        ],
        name: "RequestWithdrawalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "caller",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralReturned",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokensBurned",
                type: "uint256",
            },
        ],
        name: "SettleExpiredPosition",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
        ],
        name: "Withdrawal",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_collateralAddress",
                type: "address",
            },
        ],
        name: "_getSyntheticDecimals",
        outputs: [
            {
                internalType: "uint8",
                name: "decimals",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelTransferPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralCurrency",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralRequirement",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "contractState",
        outputs: [
            {
                internalType: "enum PricelessPositionManager.ContractState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "collateralAmount",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "numTokens",
                type: "tuple",
            },
        ],
        name: "create",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "minCollateralPerToken",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "maxCollateralPerToken",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "maxTokensToLiquidate",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
        ],
        name: "createLiquidation",
        outputs: [
            {
                internalType: "uint256",
                name: "liquidationId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "tokensLiquidated",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "finalFeeBond",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cumulativeFeeMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "collateralAmount",
                type: "tuple",
            },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "collateralAmount",
                type: "tuple",
            },
        ],
        name: "depositTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "liquidationId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
        ],
        name: "dispute",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "totalPaid",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "disputeBondPercentage",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "disputerDisputeRewardPercentage",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "emergencyShutdown",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "expirationTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "expire",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "expiryPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "financialProductLibrary",
        outputs: [
            {
                internalType: "contract FinancialProductLibrary",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "finder",
        outputs: [
            {
                internalType: "contract FinderInterface",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
        ],
        name: "getCollateral",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCurrentTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
        ],
        name: "getLiquidations",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "sponsor",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "liquidator",
                        type: "address",
                    },
                    {
                        internalType: "enum Liquidatable.Status",
                        name: "state",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "liquidationTime",
                        type: "uint256",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "tokensOutstanding",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "lockedCollateral",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "liquidatedCollateral",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "rawUnitCollateral",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "disputer",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "settlementPrice",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "finalFee",
                        type: "tuple",
                    },
                ],
                internalType: "struct Liquidatable.LiquidationData[]",
                name: "liquidationData",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "getOutstandingRegularFees",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "regularFee",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "latePenalty",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "totalPaid",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gulp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidationLiveness",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "liquidations",
        outputs: [
            {
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
            {
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                internalType: "enum Liquidatable.Status",
                name: "state",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "liquidationTime",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "tokensOutstanding",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "lockedCollateral",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "liquidatedCollateral",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "rawUnitCollateral",
                type: "tuple",
            },
            {
                internalType: "address",
                name: "disputer",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "settlementPrice",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "finalFee",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minSponsorTokens",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "payRegularFees",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "pfc",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "positions",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "tokensOutstanding",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "withdrawalRequestPassTimestamp",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "withdrawalRequestAmount",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "rawCollateral",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "transferPositionRequestPassTimestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "priceIdentifier",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rawLiquidationCollateral",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rawTotalPositionCollateral",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "numTokens",
                type: "tuple",
            },
        ],
        name: "redeem",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "amountWithdrawn",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "remargin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "numTokens",
                type: "tuple",
            },
        ],
        name: "repay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "requestTransferPosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "collateralAmount",
                type: "tuple",
            },
        ],
        name: "requestWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "setCurrentTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settleExpired",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "amountWithdrawn",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "sponsorDisputeRewardPercentage",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timerAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenCurrency",
        outputs: [
            {
                internalType: "contract ExpandedIERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalPositionCollateral",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalTokensOutstanding",
        outputs: [
            {
                internalType: "uint256",
                name: "rawValue",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newSponsorAddress",
                type: "address",
            },
        ],
        name: "transferPositionPassedRequest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "price",
                type: "tuple",
            },
        ],
        name: "transformCollateralRequirement",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "price",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "requestTime",
                type: "uint256",
            },
        ],
        name: "transformPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "requestTime",
                type: "uint256",
            },
        ],
        name: "transformPriceIdentifier",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "collateralAmount",
                type: "tuple",
            },
        ],
        name: "withdraw",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "amountWithdrawn",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "liquidationId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sponsor",
                type: "address",
            },
        ],
        name: "withdrawLiquidation",
        outputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "payToSponsor",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "payToLiquidator",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "payToDisputer",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "paidToSponsor",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "paidToLiquidator",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "rawValue",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct FixedPoint.Unsigned",
                        name: "paidToDisputer",
                        type: "tuple",
                    },
                ],
                internalType: "struct Liquidatable.RewardsData",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawPassedRequest",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "rawValue",
                        type: "uint256",
                    },
                ],
                internalType: "struct FixedPoint.Unsigned",
                name: "amountWithdrawn",
                type: "tuple",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawalLiveness",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
export class ExpiringMultiParty__factory extends ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(params, overrides) {
        return super.deploy(params, overrides || {});
    }
    getDeployTransaction(params, overrides) {
        return super.getDeployTransaction(params, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
ExpiringMultiParty__factory.bytecode = _bytecode;
ExpiringMultiParty__factory.abi = _abi;
